import {
  ICustomerVasCreate,
  ICustomerVasDetails,
  ICustomerVasGetByIdPayload,
  ICustomerVasListItem,
  ICustomerVasListSearch,
  IEditCustomerVasPayload,
} from "../../../types/master/customerVasInterface";
import { CustomerVasActionTypes, CustomerVasActions } from "../../actionTypes/master/customerVasActionTypes";

export const createCustomerVas = (payload: ICustomerVasCreate): CustomerVasActionTypes => ({
  type: CustomerVasActions.CREATE_CUSTOMER_VAS,
  payload,
});

export const getCustomerVasList = (payload: ICustomerVasListSearch): CustomerVasActionTypes => ({
  type: CustomerVasActions.GET_CUSTOMER_VAS_LIST,
  payload,
});

export const setCustomerVasList = (customerVasList: ICustomerVasListItem[]): CustomerVasActionTypes => ({
  type: CustomerVasActions.SET_CUSTOMER_VAS_LIST,
  payload: customerVasList,
});

export const setCustomerVasListPageCount = (payload: number): CustomerVasActionTypes => ({
  type: CustomerVasActions.SET_CUSTOMER_VAS_LIST_PAGE_COUNT,
  payload,
});

export const getCustomerVasDataById = (payload: ICustomerVasGetByIdPayload): CustomerVasActionTypes => ({
  type: CustomerVasActions.GET_CUSTOMER_VAS_DATA_BY_ID,
  payload,
});

export const setCustomerVasDataById = (payload: ICustomerVasDetails): CustomerVasActionTypes => ({
  type: CustomerVasActions.SET_CUSTOMER_VAS_DATA_BY_ID,
  payload,
});

export const editCustomerVas = (payload: IEditCustomerVasPayload): CustomerVasActionTypes => ({
  type: CustomerVasActions.EDIT_CUSTOMER_VAS_DATA_BY_ID,
  payload,
});
